// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3EZMO","buttons":"PendingPaymentAlert_buttons__3rCAy"};